export const UPDATE_SCORING_RULE_SEGMENT = 'UPDATE_SCORING_RULE_SEGMENT';
export const UPDATE_SCORING_RULE_SEGMENT_SUCCESS = 'UPDATE_SCORING_RULE_SEGMENT_SUCCESS';
export const UPDATE_SCORING_RULE_SEGMENT_FAILURE = 'UPDATE_SCORING_RULE_SEGMENT_FAILURE';
